export default __webpack_public_path__ + "static/media/mars-to-venus-impact.c573bed9.jpg";